import React from 'react'
import { Route, Link } from 'react-router-dom'
import images from '../images.js'

class Gallery extends React.Component {

    componentDidMount() {
        document.title = "sweaverD.com - Galleria Fantastic"
    }
    THUMBFOLDER = "public_images/thumbs"
    GID = 1

    render = () => {

        return (

            <article id="galleryPage" className="solo">
                <h1 className="nostyle"><i className="fa fa-camera-retro"><span>The Galleria Fantastic</span></i></h1>
                <p>Places I've seen (kinda goes without saying) and trails I've hiked, mostly. Each one of these pictures is worth 1024 words.&nbsp;&nbsp;

                    {/\/links$/.test(document.location.pathname) ? 
                        <Link to="/gallery">Click here to browse thumbnails.</Link>
                    : 
                        <Link to="/gallery/links">Click here to browse by image name.</Link>
                    }
                </p>                
                
                <div id="thumbNailContainer" className="grid">
                    <Route path={`${this.props.match.path}/links`} component={this.LinkGallery}></Route>
                    <Route exact path={`${this.props.match.path}`} component={this.ThumbGallery}></Route>
                </div>

            </article>
        )
    }

    ThumbGallery = () => {

        return (
            //sort by height
            images.sort((a, b) => a.h - b.h).map((img, index, array) => {
                return <div key={img.pid} className="galleryLink">
                    <Link to={`#&gid=${this.GID}&pid=${img.pid}`}>
                        <img src={`${this.THUMBFOLDER}/${img.pid}_thumb.jpg`} alt={`${img.title}`} title={`${img.title}`} />
                    </Link>
                </div>
            })

        )
    }
    LinkGallery = () => {

        var imageLinks = () => {
            //sort by pid (alpha)
            var html = images.sort((a, b) => a.pid.localeCompare(b.pid)).map((img, index, array) => {
                return <p key={img.pid} className="galleryLink">
                    <Link to={`#&gid=${this.GID}&pid=${img.pid}`}>
                        {`${img.title}`}
                    </Link>
                </p>
            })
            return html
        }
        return imageLinks()
    }
}

export default Gallery